<template>
    <div>
        <el-descriptions labelStyle="width: 100px;text-align: right;" title="" :column="2" border>
            <el-descriptions-item>
                <template slot="label">
                    查询类型
                </template>
                <span v-if="searchCondition.st === 1 && searchCondition.lang === 'zh'">中文分类选择</span>
                <span v-if="searchCondition.st === 1 && searchCondition.lang === 'en'">外文分类选择</span>
                <span v-if="searchCondition.st === 2">中文自定义条件检索</span>
                <span v-if="searchCondition.st === 3">外文自定义条件检索</span>
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    行业分类
                </template>
                {{ common.matchPatentClass(searchCondition.type) }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    专利类型
                </template>
                <span v-if="searchCondition.params.ptType === 1">发明专利</span>
                <span v-if="searchCondition.params.ptType === 2">实用新型专利</span>
                <span v-if="searchCondition.params.ptType === 3">外观设计专利</span>
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    申请号
                </template>
                {{ searchCondition.params.ptNo }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    公开号
                </template>
                {{ searchCondition.params.openNo }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    申请日
                </template>
                {{ searchCondition.params.applyStDate }}至{{ searchCondition.params.applyEdDate }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    公开（公告）日
                </template>
                {{ searchCondition.params.openStDate }}至{{ searchCondition.params.openEdDate }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    申请人/权利人
                </template>
                {{ searchCondition.params.ptProposer }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    发明（设计人）
                </template>
                {{ searchCondition.params.ptInventor }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    代理机构
                </template>
                {{ searchCondition.params.agencyName }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    代理人
                </template>
                {{ searchCondition.params.agentName }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    申请人国别
                </template>
                {{ searchCondition.params.appCoun }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    专利公开国别
                </template>
                {{ searchCondition.params.pubCountryCode }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    IPC分类号
                </template>
                {{ searchCondition.params.ptClassNo }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    洛加诺分类号
                </template>
                {{ searchCondition.params.ljnClassNo }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    申请人地址
                </template>
                {{ searchCondition.params.applyAddress }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    是否战略性新兴产业
                </template>
                <span v-if="searchCondition.params.eicFlag === 0">否</span>
                <span v-if="searchCondition.params.eicFlag === 1">是</span>
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    标题
                </template>
                {{ searchCondition.params.ptName }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    摘要
                </template>
                {{ searchCondition.params.abs }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    权利要求书
                </template>
                {{ searchCondition.params.claimsPath }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    排序
                </template>
                <span v-if="searchCondition.params.sortFeild === 1 && searchCondition.params.sortType === 1">申请日升序</span>
                <span v-if="searchCondition.params.sortFeild === 1 && searchCondition.params.sortType === 2">申请日倒序</span>
                <span v-if="searchCondition.params.sortFeild === 2 && searchCondition.params.sortType === 1">公开日升序</span>
                <span v-if="searchCondition.params.sortFeild === 2 && searchCondition.params.sortType === 2">公开日倒序</span>
                <span v-if="searchCondition.params.sortFeild === 3 && searchCondition.params.sortType === 1">授权日升序</span>
                <span v-if="searchCondition.params.sortFeild === 3 && searchCondition.params.sortType === 2">授权日降序</span>
            </el-descriptions-item>
        </el-descriptions>
    </div>
</template>

<script>
import common from '../../../utils/common';

export default {
    data() {
        return {
            searchCondition: {}
        }
    },
    created() {
    },
    mounted() {
        var condition = localStorage.getItem("searchInfo");
        if (condition != null || condition !== '') {
            this.searchCondition = JSON.parse(condition);
        }
    },
    methods: {

    }
}
</script>

<style>

</style>